var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackO(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3793 1.62549C14.5504 0.792084 13.2085 0.792084 12.3795 1.62201L10.124 3.88435C9.60412 3.75239 9.06183 3.67426 8.50054 3.67426C7.31061 3.67426 6.19494 3.99547 5.22952 4.54933L3.96879 3.30618L1 6.32378L2.40927 7.71279C2.06559 8.51841 1.87216 9.4039 1.87216 10.3363C1.87216 14.0102 4.84612 17 8.50054 17C12.155 17 15.1289 14.0102 15.1289 10.3363C15.1289 8.80836 14.6091 7.402 13.7456 6.27691L15.3811 4.63615C16.2066 3.80622 16.2066 2.45715 15.3793 1.62549ZM8.49881 14.7516C6.0775 14.7516 4.10868 12.7705 4.10868 10.338C4.10868 10.0133 4.14667 9.69906 4.2123 9.39348C5.02919 9.864 6.08786 9.74941 6.77695 9.0497C7.5403 8.2736 7.58176 7.05822 6.90994 6.22829C7.40387 6.03383 7.93925 5.92445 8.50054 5.92445C10.9219 5.92445 12.8907 7.90551 12.8907 10.338C12.8907 12.7705 10.9201 14.7516 8.49881 14.7516Z",
    fill: "black",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackO);
export default __webpack_public_path__ + "static/media/black-o.108a548fc7745e0dd76bec7d436664b8.svg";
export { ForwardRef as ReactComponent };